import 'jquery';
import { $body } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Image Slider
 */
const ImageSlider = (() => {
  /**
   * Selector
   */
  const Selector = {
    IMAGE_SLIDER: '.image-slider'
  };

  /**
   * ImageSlider
   *
   * @class
   * @augments HtmlElement
   */
  class ImageSlider extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._init();
    }

    // Private

    /**
     * Initializes the slider
     *
     * @return void
     */
    _init() {
      this.$element.owlCarousel({
        items: 1,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        autoplay: true,
        autoplayHoverPause: true,
        loop: true
      });
    }
  }

  return ImageSlider._getElements($body.find(Selector.IMAGE_SLIDER), ImageSlider);
})(jQuery);

export default ImageSlider;
